<template>
  <v-app-bar
    app
    flat
    height="64"
  >
    <v-row>
      <v-col class="flex-grow">
        <v-row class="d-flex flex-nowrap">
          <v-col
            md="auto"
          >
            <search-bar
              v-if="showSearchBar"
              class="client-search"
              menu-class="header-bar-search"
            />
          </v-col>

          <v-col
            v-if="showDataFreshness && dataFreshnessIndicators"
            md="auto"
          >
            <v-dialog
              v-model="toggleDataFreshnessLegend"
              hide-overlay
              max-width="600"
            >
              <template v-slot:activator="{ on }">
                <v-row
                  class="cursor-pointer pt-3 align-center caption flex-nowrap"
                  v-on="on"
                >
                  <v-col class="col-1 px-0 data-refresh-icon">
                    <v-icon
                      class="mr-1"
                      :color="dataFreshnessIndicators.color"
                      small
                    >
                      {{ dataFreshnessIndicators.icon }}
                    </v-icon>
                  </v-col>

                  <v-col
                    v-if="$vuetify.breakpoint.width > 850"
                    class="col-10 ml-2"
                  >
                    <v-row
                      :class="`
                        font-weight-${dataFreshnessIndicators.subtext ? 'bold' : 'medium'}
                        ${dataFreshnessIndicators.subtext ? '' : 'line-height-double'}
                      `"
                    >
                      <v-col class="pa-0 text-capitalize text-truncate data-refresh-text">
                        {{ dataFreshnessIndicators.text }}
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="dataFreshnessIndicators.subtext"
                      class="mt-1 text-capitalize"
                    >
                      <v-col class="pa-0 text-truncate data-refresh-text">
                        {{ dataFreshnessIndicators.subtext }}

                        <span class="font-weight-medium">
                          {{ dataFreshnessIndicators.datetime }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>

              <v-card>
                <v-card-title class="title px-9 py-6">
                  <v-row>
                    <v-col
                      class="flex-grow py-0 darkestblue--text"
                    >
                      Data Status
                    </v-col>

                    <v-spacer />

                    <v-col
                      class="flex-shrink-1 col-2 py-0 text-right"
                    >
                      <v-btn
                        :ripple="false"
                        icon
                        @click.stop="hideLegendDataFreshness"
                      >
                        <v-icon color="brightblue">
                          close
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-divider />

                <v-card-text class="px-6 pb-6">
                  <v-row
                    class="mt-1 text-capitalize"
                  >
                    <v-col class="ma-6">
                      <v-row>
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            Status
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            {{ dataFreshnessIndicators.text }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="dataFreshnessIndicators.subtext"
                        class="pt-3"
                      >
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            {{ dataFreshnessIndicators.subtext }}
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            {{ dataFreshnessIndicators.datetime }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row
                        v-if="dataFreshnessIndicators.subtext && dataFreshnessIndicators.datetime"
                        class="pt-3"
                      >
                        <v-col>
                          <v-row class="pr-1 font-weight-bold">
                            Timezone
                          </v-row>

                          <v-row class="mt-2 font-weight-medium">
                            Local Time
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        class="d-flex"
        md="auto"
      >
        <v-row class="d-flex flex-nowrap justify-end justify-xl-end justify-lg-end justify-md-end justify-sm-end justify-xs-center align-center pt-1">
          <v-col
            v-if="showLegendBar"
            class="header-action col-1 pl-sm-0 text-right text-sm-end  text-xs-center"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-btn
                  color="coolgray"
                  icon
                  small
                  v-bind="tooltipAttrs"
                  v-on="tooltipOn"
                  @click="toggleLegend"
                >
                  <v-icon>
                    info
                  </v-icon>
                </v-btn>
              </template>

              <span>Legend</span>
            </v-tooltip>

            <legend-bar />
          </v-col>

          <v-col
            class="header-action col-1 pl-sm-0 text-right text-sm-end  text-xs-center"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="coolgray"
                  icon
                  small
                  target="_blank"
                  title="Release Notes"
                  to="/docs/releases"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>
                    notifications_none
                  </v-icon>
                </v-btn>
              </template>

              <span>Release Notes</span>
            </v-tooltip>
          </v-col>

          <v-col
            class="header-action col-1 pl-sm-0 text-right text-sm-end  text-xs-center"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="coolgray"
                  icon
                  small
                  target="_blank"
                  title="Feedback"
                  href="https://forms.gle/L3rmX38g7DYodqPt6"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>
                    comment
                  </v-icon>
                </v-btn>
              </template>

              <span>Feedback</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')
const {
  mapGetters: mapToolsGetters,
  mapState: mapToolsState,
} = createNamespacedHelpers('tools')

export default {
  name: 'Header',
  components: {
    LegendBar: () => import('src/delivery/components/modals/LegendBar'),
    SearchBar: () => import('src/tools/components/search/SearchBar'),
  },
  computed: {
    ...mapAuthGetters(['inDarkMode', 'inDemoMode', 'isInternalWriter', 'permissions']),
    ...mapToolsGetters([
      'currentColumns',
      'currentGroups',
      'didLastRefreshFail',
      'indicateDataRefreshed',
      'indicateDataRefreshing',
      'isDataRefreshing',
      'reportKey',
      'storedItems',
    ]),
    ...mapLayoutGetters([
      'showDataFreshness',
      'showLegendBar',
      'showSearchBar',
    ]),
    ...mapToolsState({
      isLegendModalVisible: (state) => state.isLegendModalVisible,
      showDataFreshnessLegend: (state) => state.showDataFreshnessLegend,
    }),

    toggleDataFreshnessLegend: {
      get() {
        return this.showDataFreshnessLegend
      },
      set(value) {
        this.$store.commit('tools/showDataFreshnessLegend', value)
      },
    },
    /**
     * Gets the view data for the data freshness indicator
     *
     * @returns {Object} indicator { color, datetime, icon, subtext, text }
     */
    dataFreshnessIndicators() {
      const {
        indicateDataRefreshed,
        indicateDataRefreshing,
      } = this

      if (indicateDataRefreshing) return indicateDataRefreshing

      if (indicateDataRefreshed) return indicateDataRefreshed

      return false
    },
  },
  watch: {
    inDemoMode() {
      this.$store.dispatch('tools/getDataRefresh')
    },
  },
  created() {
    this.$store.dispatch('tools/getDataRefresh')
  },
  methods: {
    toggleLegend() {
      this.$store.commit('delivery/isLegendModalVisible', !this.isLegendModalVisible)
    },
    hideLegendDataFreshness() {
      this.toggleDataFreshnessLegend = false
    },
  },
}
</script>

<style lang="scss" scoped>
.client-search {
  min-width: 120px;
  max-width: 320px;
}

.header-action {
  min-width: 52px;
}

.data-refresh-icon {
  max-width: 16px;
}

.data-refresh-text {
  min-width: fit-content;
}

.v-select.v-text-field input {
  max-width: 0 !important;
}

.create-item {
  min-width: 21px !important;
  padding: 0 !important;
}

.line-height-double {
  line-height: 2;
}

</style>
